import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "case-study-image-container" }
const _hoisted_2 = {
  key: 0,
  class: "placeholder-gradient d-flex align-center justify-center"
}
const _hoisted_3 = { class: "pa-6 md:pa-8 d-flex flex-column h-100" }
const _hoisted_4 = { class: "d-flex align-center gap-2 mb-3" }
const _hoisted_5 = { class: "case-study-title mb-3" }
const _hoisted_6 = { class: "case-study-summary text-grey-darken-2 mb-4 flex-grow-1" }
const _hoisted_7 = { class: "d-flex align-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "case-study-card overflow-hidden transition-all duration-300 hover:shadow-lg",
    href: _ctx.caseStudy.link,
    target: "_blank",
    rounded: "lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "case-study-image",
                  style: _normalizeStyle({ backgroundImage: _ctx.imageUrl ? `url(${_ctx.imageUrl})` : undefined })
                }, [
                  (!_ctx.imageUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_icon, {
                          size: "64",
                          color: "white",
                          class: "opacity-70"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-lightbulb-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 4)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    color: "#5539EC",
                    variant: "tonal",
                    class: "text-none font-weight-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.caseStudy.company), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.caseStudy.title), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.caseStudy.summary), 1),
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", {
                    class: "text-body-2 font-weight-medium",
                    style: {"color":"#5539EC"}
                  }, " Read case study ", -1)),
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#5539EC"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-arrow-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["href"]))
}